import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      //路由path
      path: '/index',
      //路由name
      name: 'INDER',
      //路由组件
      component: () => import('../page/main/customNew/index'),
      meta: { noCache: true }
    },
    {
      path: '/login',
      name: 'LOGIN',
      component: () => import('../components/login/login.vue'),
      meta: { noCache: true }
    },
    {
      path: '/homePage',
      name: 'LOGIN',
      component: () => import('../page/main/customNew/homePage'),
      meta: { noCache: true }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js